import initialStates from '../../initialStates';
import {
    CLEAR_CHAPTER_STATE,
    CREATE_CHAPTER_SUCCESS,
    FETCH_CHAPTER_LIST_FAILURE,
    FETCH_CHAPTER_LIST_REQUEST,
    FETCH_CHAPTER_LIST_SUCCESS,
} from './chapter-actions';

const chapterReducer = (state = initialStates.chapter, action) => {
    let newState = {};
    switch (action.type) {
    case FETCH_CHAPTER_LIST_REQUEST:
        newState = Object.assign({}, state, { isLoading: true });
        break;
    case FETCH_CHAPTER_LIST_SUCCESS:
        newState = Object.assign({}, state, {
            isLoading: false,
            list: action.data.content,
            page: action.data.number,
            size: action.data.size,
            totalElements: action.data.totalElements,
        });
        break;
    case FETCH_CHAPTER_LIST_FAILURE:
        newState = Object.assign({}, state, { isLoading: false });
        break;

    case CLEAR_CHAPTER_STATE:
        newState = initialStates.chapter;
        break;
    case CREATE_CHAPTER_SUCCESS:
        newState = {
            ...state,
            selectedChapter: action.data,
        };
        break;
    default:
        newState = state;
    }
    return newState;
};

export default chapterReducer;
